<template>
  <base-field
    :label="label"
    :id="$attrs.id"
    :required="$attrs.required"
    :tight="tight"
    :error-messages="errorMessages"
  >
    <input v-bind="$attrs" v-on="inputListeners" class="form-control" :value="value" ref="input" />
  </base-field>
</template>

<script>
import BaseField from '@/components/base-field';

export default {
  name: 'BaseInput',
  components: {
    BaseField,
  },
  props: {
    label: {
      type: String,
    },
    tight: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    inputListeners() {
      const vm = this;
      return {
        ...vm.$listeners,
        input(event) {
          vm.$emit('input', event.target.value);
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
input,
select {
  width: 100%;
  border: 1px solid #ced4da !important;
  background-image: none !important;

  &.invalid {
    border-color: red !important;
  }
}
</style>
